import { endpointArticles } from '../articles/endpointArticles';
import { Article } from '../models/articles';

export const findArticleById = (
  id: string,
  articles: Article[] = endpointArticles
): Article | undefined => {
  for (const article of articles) {
    if (article.id === id) {
      return article;
    }
    if (article.children) {
      const found = findArticleById(id, article.children);
      if (found) {
        return found;
      }
    }
  }
  return undefined;
};
